export default __webpack_public_path__ + "static/media/section2-bg.f69ad4a8.png";